// Client-facing / lead-gen pages that intentionally opt OUT of the
// homepage/blog "developer terminal" visual identity (code-canvas background,
// floating terminal widget, monospace base font) in favor of a warmer,
// human, conversion-focused look. See app/layout.tsx's `inter` font and the
// .font-warm Tailwind utility.
const CONVERSION_PAGE_PREFIXES = [
  "/hire",
  "/best",
  "/guides",
  "/alternatives",
  "/companies",
  "/services",
];

export function isConversionPage(pathname: string): boolean {
  return CONVERSION_PAGE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
